<template>
    <div
        class="flex w-full flex-col rounded-lg p-4 shadow-sm ring-1 ring-iron-300"
    >
        <div class="flex items-start justify-between">
            <div>
                <h2 class="text-xl font-medium text-iron-900">
                    {{ pricingData.title }}
                </h2>

                <p class="mt-4">
                    <span class="text-2xl font-bold text-iron-900">
                        {{ pricingData.currency_price_yearly }}
                    </span>

                    <span class="text-lg font-semibold text-iron-800"
                        >/user/mo
                    </span>
                    <span> billed annualy </span>
                </p>
                <p class="mt-1">
                    <span>
                        {{ pricingData.currency_price_monthly }}
                    </span>
                    <span class="text-sm">/user/mo </span>
                    <span class="text-sm">month-to-month </span>
                </p>
            </div>
        </div>
        <p class="mt-1 text-sm text-iron-600">
            {{ pricingData.hasMinUsers ? "min. 10 users" : "&nbsp;" }}
        </p>

        <ul
            class="relative flex-grow overflow-hidden transition-all duration-300 ease-out"
            :class="[expanded ? 'max-h-[100px]' : ' max-h-full']"
        >
            <li
                v-for="(feature, i) in pricingData.features"
                :key="i"
                class="mt-3 flex items-center gap-2"
            >
                <Check
                    class="text-iron-900"
                    :size="20"
                    :stroke-width="1.75"
                    absolute-stroke-width
                />

                {{ feature }}
            </li>

            <div
                v-if="expanded"
                class="absolute -bottom-1 h-8 w-full bg-gradient-to-t from-white to-transparent"
            ></div>
        </ul>

        <Button v-if="expanded" variant="ghost" @click="expanded = !expanded"
            >see all features</Button
        >

        <div class="w-full">
            <div class="w-full">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Check } from "lucide-vue-next";
import type { PricingData } from "../composables/usePricingData";
import { ref } from "vue";
import { Button } from "@/components/ui/button";

defineProps<{
    pricingData: PricingData;
}>();

const expanded = ref(true);
</script>
